import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manageRoleList: { loading: false, data: null, error: null },
  createmanageRole: { loading: false, data: null, error: null },
  updatemanageRole: { loading: false, data: null, error: null },
  deleteRole: { loading: false, data: null, error: null },
  addFeatureRole: { loading: false, data: null, error: null },
};
export const ManageRole = createSlice({
  name: "manageRole",
  initialState,
  reducers: {
    fetchmanageRoleListRequest: (manageRole, action) => {
      manageRole.manageRoleList.loading = true;
      manageRole.manageRoleList.error = null;
    },
    fetchmanageRoleListSuccess: (manageRole, action) => {
      manageRole.manageRoleList.data = action.payload;
      manageRole.manageRoleList.loading = false;
      manageRole.manageRoleList.error = null;
    },
    fetchmanageRoleListFaliure: (manageRole, action) => {
      manageRole.manageRoleList.data = null;
      manageRole.manageRoleList.loading = false;
      manageRole.manageRoleList.error = action.payload;
    },
    createmanageRoleRequest: (manageRole, action) => {
      manageRole.createmanageRole.loading = true;
      manageRole.createmanageRole.error = null;
    },
    createmanageRoleSuccess: (manageRole, action) => {
      manageRole.createmanageRole.data = action.payload;
      manageRole.createmanageRole.loading = false;
      manageRole.createmanageRole.error = null;
      // update list remainning
      manageRole.manageRoleList = addNewRoleSuccess(action.payload, {
        ...manageRole.manageRoleList,
      });
    },
    createmanageRoleFaliure: (manageRole, action) => {
      manageRole.createmanageRole.data = null;
      manageRole.createmanageRole.loading = false;
      manageRole.createmanageRole.error = action.payload;
    },
    updatemanageRoleRequest: (manageRole, action) => {
      manageRole.updatemanageRole.loading = true;
      manageRole.updatemanageRole.error = null;
    },
    updatemanageRoleSuccess: (state, action) => {
      state.updatemanageRole.data = action.payload;
      state.updatemanageRole.loading = false;
      state.updatemanageRole.error = null;
      //add update values to list
      // state.manageRoleList = updateRoleSuccess(
      //   action.payload,
      //   state.manageRoleList
      // );
    },
    updatemanageRoleFaliure: (manageRole, action) => {
      manageRole.updatemanageRole.data = null;
      manageRole.updatemanageRole.loading = false;
      manageRole.updatemanageRole.error = action.payload;
    },
    deletemanageRoleRequest: (manageRole, action) => {
      manageRole.deleteRole.loading = true;
      manageRole.deleteRole.error = null;
    },
    deletemanageRoleSuccess: (manageRole, action) => {
      manageRole.deleteRole.data = action.payload;
      manageRole.deleteRole.loading = false;
      manageRole.deleteRole.error = null;
      // add data to list
      manageRole.manageRoleList = deleteRole(
        action.payload,
        manageRole.manageRoleList
      );
    },
    deletemanageRoleFaliure: (manageRole, action) => {
      manageRole.deleteRole.data = null;
      manageRole.deleteRole.loading = false;
      manageRole.deleteRole.error = action.payload;
    },
    addFeatureRoleRequest: (manageRole, action) => {
      manageRole.addFeatureRole.loading = true;
      manageRole.addFeatureRole.error = null;
      manageRole.addFeatureRole.data = null;
    },
    addFeatureRoleSuccess: (state, action) => {
      state.addFeatureRole.data = action.payload;
      state.addFeatureRole.loading = false;
      state.addFeatureRole.error = null;
    },
    addFeatureRoleFaliure: (manageRole, action) => {
      manageRole.addFeatureRole.data = null;
      manageRole.addFeatureRole.loading = false;
      manageRole.addFeatureRole.error = action.payload;
    },
  },
});
export const {
  fetchmanageRoleListRequest,
  fetchmanageRoleListSuccess,
  fetchmanageRoleListFaliure,
  createmanageRoleRequest,
  createmanageRoleSuccess,
  createmanageRoleFaliure,
  updatemanageRoleRequest,
  updatemanageRoleSuccess,
  updatemanageRoleFaliure,
  deletemanageRoleRequest,
  deletemanageRoleSuccess,
  deletemanageRoleFaliure,
  addFeatureRoleRequest,
  addFeatureRoleSuccess,
  addFeatureRoleFaliure,
} = ManageRole.actions;

function addNewRoleSuccess(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}
function updateRoleSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((value) => {
    if (value._id !== dataToUpdate._id) return value;
       return { ...value, ...dataToUpdate };
  });

  return state;
}
// replace lead with role
function deleteRole(dataToRemove, state) {
  state = state.map((role) => {
    if (role._id !== dataToRemove.leadId) return role;
    if (!role.notes?.length) return role;

    return {
      ...role,
      notes: role.notes.filter((note) => note._id !== dataToRemove.noteId),
    };
  });
  return state;
}
export const getmanageRoleListState = (store) =>
  store.manageRole?.manageRoleList;
  export const getCreateManageRoleState = (store) =>
  store.manageRole;
  
  export const getAddFeatureRoleData = (store) => store.manageRole;
  export const getCreateManageRoleData = (store) => store.manageRole?.createmanageRole;
  export const getDeleteRoleData = (store) => store.manageRole?.deleteRole;
  export const getUpdateManageRoleData = (store) => store.manageRole?.updatemanageRole;

  

export default ManageRole.reducer;
